import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import { CategoryIdParameter, getProductsInParentCategory } from "@SupplyLand/Services/SupplyLandService";
import { CustomActions } from "@SupplyLand/Store/Components/CustomPromotions/PromoCategoryReducer";
import { DispatchProp } from "react-redux";

interface OwnProps {
    apiResult: ProductDto[];
    apiParameter: CategoryIdParameter;
    error?: unknown;
}

type Props = OwnProps & DispatchProp<CustomActions>;

type HandlerType = Handler<CategoryIdParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductsInParentCategory(props.apiParameter);
    } catch (error) {
        logger.error(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        props.dispatch({
            type: "SupplyLand/Promotions/ReturnGetProductsInParentCategory",
            products: <ProductDto[]>props.apiResult,
            categoryId: props.apiParameter.categoryId ?? "",
        });
        // markSkipOnCompleteIfOnSuccessIsSet(props);
        // props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        // markSkipOnCompleteIfOnErrorIsSet(props);
        // props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const loadPromoCategoryProducts = createHandlerChainRunner(chain, "loadPromoCategoryProducts");

export default loadPromoCategoryProducts;
